// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
    production: true,
    staging: false,
    local: false,
    firebaseConfig: {
        apiKey: 'AIzaSyCc7pxYVr70QF861u1J13Vt10APWePTgg8',
        authDomain: 'sopo-development.firebaseapp.com',
        databaseURL: 'https://sopo-development.firebaseio.com',
        projectId: 'sopo-development',
        storageBucket: 'sopo-development.appspot.com',
        messagingSenderId: '1052983596892',
        appId: '1:1052983596892:web:31a4a2ec14a65ebd',
        measurementId: 'G-7JPJ1FTHVG'
    },
    apiUrl: 'https://api.prod.playsopo.com/',
    gameServerDomain: '.prod.playsopo.com',
    webClientId: '1052983596892-jstt96m0aant2q1uqnrqk4tnbc6g086i.apps.googleusercontent.com',
    cmsUrl: 'https://cms.playsopo.com/api/',
    bearerToken: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijc3M',
    advertisementID: 'ca-app-pub-3940256099942544/1712485313', // This id is for test purposes.
    mapsApiKey: 'AIzaSyC6iT7FS3YL5G3x2kWfv_UKbg_kVUTVWrQ',
    nftAggregatorUrl: 'https://nft-aggregator-dot-sopo-development.uc.r.appspot.com/',
    sentryDsnDesktop: 'https://034486123694f7532d2048470e49b789@o4508327876952064.ingest.us.sentry.io/4508483209592832',
    sentryDsnWeb: 'https://7fa8b4d537941a12406b7e04ac59be4f@o4508327876952064.ingest.us.sentry.io/4511026183471104',
    iap: {
        ios: 'appl_XsmOOZTexjYdqevgSSGVBJwGjth',
        android: 'goog_TqFVlOXSBJYVchNfVbiWQyHAqTZ',
        web: 'rcb_eztcswFLIiJJOoQIWYHfyNLNdhPz',
    },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
